// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardPagesLayout_root__4EWhp","filters":"DashboardPagesLayout_filters__1wqgp","content":"DashboardPagesLayout_content___jpYd"};